module.exports = __webpack_public_path__ + "static/media/iotnet3.c0ce34e1.jpeg";